<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <form @keydown.enter.prevent="submit()">
      <!-- data provider  -->
      <div>
        <!-- title  -->
        <h2 class="mb-1" style="display: flex">
          {{ $t('Kontaktiniai duomenys') }}
          <el-tooltip
            tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Nauja prokūra. Kontaktiniai duomenys"
            title
          ></el-tooltip>
        </h2>
        <div v-for="(item, index) in formData.pro_principals" :key="item.id">
          <contact-information-card :index="index" :item="item" />
        </div>
        <div v-for="(item, index) in formData.procurators" :key="item.id">
          <contact-information-card :index="index" :item="item" />
        </div>
        <div v-for="(item, index) in formData.payers" :key="item.id">
          <contact-information-card :index="index" :item="item" />
        </div>
      </div>
      <!-- actions  -->
      <v-card-actions>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <el-button
            class="mr-1"
            color="secondary"
            icon="atgal"
            title="Atgal"
            @click.native.stop="back()"
            :loading="loading"
          />
          <el-button
            v-if="!modeReadonly"
            title="Tęsti"
            :loading="loading"
            @click.native="setLang()"
            color="primary"
            icon="pirmyn"
          />
        </v-row>
      </v-card-actions>
    </form>
    <!-- modal  -->
    <modal-mandate-language
      v-if="showMandateLanguage"
      v-model="showMandateLanguage"
      @confirmData="beforeNext"
      :selected="selectedLang"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import unsavedData from '@/mixins/unsavedData'
import ContactInformationCard from './components/ContactInformationCard'
import ModalMandateLanguage from '@/components/modals/ModalMandateLanguage'

export default {
  name: 'ProcurationStep3',
  components: {
    ContactInformationCard,
    ModalMandateLanguage,
  },
  mixins: [userRole, unsavedData],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      showAddPerson: false,
      loading: false,
      formData: {},
      showMandateLanguage: false,
      selectedLang: null,
    }
  },
  computed: {
    getId() {
      return this.$route.params.id || null
    },
    modeReadonly() {
      return false
    },
  },
  created() {
    this.getData()
  },
  methods: {
    setLang(){
      this.showMandateLanguage = true
    },
    beforeNext(lang){
      this.formData.bilingual = lang == '1' ? true : false
      this.next()
    },
    next() {
      this.saveData()
    },
    back() {
      this.$emit('gotoStep', { step: '2', id: this.getId })
    },
    getData() {
      if (this.getId) {
        this.pageloading = true

        this.$axios
          .get(`in-journals/${this.getId}`)
          .then((res) => {
            this.formData = res.data.inJournal
            this.formData.pro_principals = this.formData.pro_principals || this.$set(this.formData, 'pro_principals', [])
            this.formData.procurators = this.formData.procurators || this.$set(this.formData, 'procurators', [])
            this.formData.payers = this.formData.payers || this.$set(this.formData, 'payers', [])
            this.selectedLang = res.data.inJournal.bilingual
            this.initialForm()
            if([803,804,807,808,810,811,812,813,815,816].includes(this.formData.status)){
              this.$router.push({ name: 'savDocuments' })
            }
          })
          .catch((err) => {
            if (err.response.status === 404) {
              return this.$router.push({ name: 'sav404' })
            } else {
              this.$root.$emit('DATA_ERROR', err.response.data.message)
            }
          })
          .finally(() => {
            this.pageloading = false
          })
      }
    },
    saveData(toRoute) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          if (toRoute) {
            formData.button = 'back'
          } else {
            formData.button = 'next'
          }

          formData.contacts = [...formData.pro_principals, ...formData.procurators, ...formData.payers]

          let url = `in-journals/${this.getId}/contacts`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_STEP')
              // then
              this.initialForm()
              if (toRoute) {
                this.goToRoute()
              } else {
                this.$emit('gotoStep', { step: '4', id: this.getId })
              }
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR_STEP')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
